import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { ASSETS } from "../../data/site";

const links = [
  { href: "#rooms", label: "Rooms" },
  { href: "#availability", label: "Availability" },
  { href: "#amenities", label: "Amenities" },
  { href: "#location", label: "Location" },
  { href: "#inquiry", label: "Contact" },
];

export default function Navbar({ onBook }) {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all ${
        scrolled ? "bg-white/95 backdrop-blur border-b-4 border-slate-900" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 h-20 flex items-center justify-between">
        <a href="#top" data-testid="navbar-logo" className="flex items-center gap-2">
          <img src={ASSETS.logo} alt="UniversalHouse TX" className="h-12 sm:h-14 w-auto rounded-xl" />
        </a>
        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="font-fredoka font-semibold text-slate-900 hover:text-brand-red transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <button
            data-testid="navbar-book-btn"
            onClick={onBook}
            className="hidden sm:inline-flex font-fredoka font-bold text-base sm:text-lg bg-brand-red text-white border-4 border-slate-900 rounded-full px-5 sm:px-6 py-2.5 neo-shadow-sm neo-press"
          >
            Book Your Stay
          </button>
          <button
            data-testid="navbar-menu-toggle"
            onClick={() => setOpen(!open)}
            className="lg:hidden w-11 h-11 grid place-items-center rounded-full border-4 border-slate-900 bg-white neo-shadow-sm"
            aria-label="Toggle menu"
          >
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>
      {open && (
        <div className="lg:hidden bg-white border-b-4 border-slate-900 px-6 py-4 space-y-3">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              data-testid={`mobile-nav-link-${l.label.toLowerCase()}`}
              className="block font-fredoka font-semibold text-lg text-slate-900"
            >
              {l.label}
            </a>
          ))}
          <button
            data-testid="mobile-book-btn"
            onClick={() => { setOpen(false); onBook(); }}
            className="w-full font-fredoka font-bold text-lg bg-brand-red text-white border-4 border-slate-900 rounded-full px-6 py-3 neo-shadow-sm"
          >
            Book Your Stay
          </button>
        </div>
      )}
    </header>
  );
}
